import styled from 'styled-components';
// import wur from '../../assets/wur-logo.png';
import cv100 from '../../assets/logos/cv100.png';
import { footerBackground } from '../../style/colors';

const MainContainer = styled.footer`
    background: ${footerBackground};
    padding: 16px 5%;
`;

const LogoContainer = styled.div`
    display: flex;
    /* justify-content: space-evenly; */
    justify-content: flex-end;
    gap: 32px;
`;
const LogoImg = styled.img`
    max-height: 60px;
    /* mix-blend-mode: darken; */
`;

const Footer = () => {
    return (
        <MainContainer>
            <LogoContainer>
                <LogoImg src={cv100} alt="Glastuinbouw club van 100" />
            </LogoContainer>
        </MainContainer>
    );
};

export default Footer;
